import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { api, fmt } from "../lib/api";
import { useApp } from "../context/AppContext";

export default function PaymentReturn() {
  const [params] = useSearchParams();
  const [status, setStatus] = useState("checking");
  const [data, setData] = useState(null);
  const nav = useNavigate();
  const { refresh } = useApp();

  useEffect(() => {
    const sid = params.get("session_id");
    if (!sid) { nav("/cashier"); return; }
    let attempts = 0;
    const poll = async () => {
      attempts++;
      try {
        const r = await api.get(`/payments/status/${sid}`);
        if (r.data.payment_status === "paid") {
          setStatus("success"); setData(r.data); await refresh(); return;
        }
        if (r.data.status === "expired") { setStatus("expired"); return; }
      } catch {}
      if (attempts < 8) setTimeout(poll, 2000);
      else setStatus("pending");
    };
    poll();
  }, [params, nav, refresh]);

  return (
    <div className="max-w-md mx-auto px-6 py-20">
      <div className="lux-card p-10 text-center">
        {status==="checking" && <><div className="text-[#d4af37] font-serif text-2xl mb-2">Processing payment…</div><div className="text-white/50 text-sm">Checking with Stripe.</div></>}
        {status==="success" && <>
          <div className="text-emerald-400 font-serif text-3xl mb-2">Payment Complete</div>
          <div className="text-white/70">+ {fmt(data.credits, data.balance_currency)} added</div>
          <button data-testid="back-to-lobby" onClick={()=>nav("/lobby")} className="btn-gold mt-6 px-6 py-3 rounded-md">Back to Lobby</button>
        </>}
        {status==="expired" && <><div className="text-red-400 font-serif text-2xl">Session expired</div><button onClick={()=>nav("/cashier")} className="btn-ghost mt-6 px-6 py-3 rounded-md">Back</button></>}
        {status==="pending" && <><div className="text-yellow-400 font-serif text-2xl">Still processing</div><div className="text-white/50 text-sm mt-2">Check back in a few moments.</div></>}
      </div>
    </div>
  );
}
